import {
  Box,
  Grid,
  TextField,
  MenuItem,
  Typography,
  useTheme,
} from "@mui/material";
import RootComponents from "../../components/common/RootComponents";
import TableCard from "../../components/common/TableCard";
import styles from "./MassMailing.module.css";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { customTextColor } from "../../utils/const";
import attachement from '../../assets/images/attach.png';
import resume from '../../assets/images/resume.png';
import profile_image from "../../assets/images/ajit_image.jpeg";


const MassMailingPortalNew = () => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [jobType, setJobType] = useState("");

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleJobTypeChange = (event) => {
    setJobType(event.target.value);
  };

  const navigate = useNavigate()
  return (
    // <RootComponents>
      <>
      <Box className={styles.candidate_structure}>
        <Box className={styles.job_serach_result_heading}>
          <Typography sx={{ color: customTextColor }}>
            Instant Mass Mailing Portal
          </Typography>
        </Box>
        <Grid container className={styles.candidates_details}>
          <Grid container >
            <Grid item xs={12} sm={6} md={3} lg={3} xl={3} >
              <TableCard

                count="575"
                text="Matching Mailing"
                customStyle={{ backgroundColor: "white" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3} xl={3} >
              <TableCard

                count="25"
                text="Sent to Bench Sales "
                customStyle={{ backgroundColor: "white" }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3} lg={3} xl={3} >
              <TableCard

                count="550"
                text="Sent to Candidate  "
                customStyle={{ backgroundColor: "white" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3} xl={3} >
              <TableCard

                count="2500"
                text="Credit Deducted"
                customStyle={{ backgroundColor: "white" }}
              />
            </Grid>

          </Grid>


        </Grid>

        <Grid container className={styles.candidates_name}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Box sx={{ color: customTextColor, padding: '0 0 0 8px' }} >
              <Typography>
                {" "}
                Subject:  <b>Looking for Senior Network Engineer at Taxes TX</b>{" "}
            </Typography>

            </Box>
            <hr></hr>
          </Grid>

          <Grid
          
            container
            className={styles.profile_details_view}
            sx={{ color: customTextColor, margiTop: "10px" }}
          >
            <Grid
              item
              md={6}
              lg={6}
              sx={{ display: "block !important" }}
              className={styles.profile_details_views}
            >
      
              <ul style={{ listStyleType: "square", padding: "0 5px 0" }}>
                <Box>
                  <li>
                    <Typography>
                      Job Title:  <b>Senior Network Engineer </b>
                    </Typography>
                  </li>
                </Box>

                <Box>
                  <li>
                    <Typography>
                      Select Job Type:   <b> Contract/ C2H/Full Time/</b>
                    </Typography>
                  </li>
                </Box>

                <Box>
                  <li>
                    <Typography>
                      Location:  <b>  PST, California, Taxes  </b>
                    </Typography>
                  </li>
                </Box>

                <Box sx={{ marginBottom: "0 !important" }}>
                  <li>
                    <Typography>
                      Mail from:   <b> rohit@meetpeople.com </b>
                    </Typography>
                  </li>
                </Box>

              </ul>
            </Grid>

            <Grid
              item
              md={6}
              lg={6}
              sx={{ display: "block !important",  }}
              className={styles.profile_details_views}
            >
              <ul style={{ listStyleType: "square", }}>
                <Box>
                  <li>
                    <Typography>
                      Experience:  <b>12 Years </b>
                    </Typography>
                  </li>
                </Box>
                <Box>
                  <li>
                    <Typography>
                      Work Preference: <b> Onsite, Hybrid, Remote </b>
                    </Typography>
                  </li>
                </Box>

                <Box>
                  <li>
                    <Typography>
                      Work Authorization:  <b>GC, USC, OPT </b>
                    </Typography>
                  </li>
                </Box>


                <Box sx={{ marginBottom: "0 !important" }}>
                  <li>
                    <Typography>
                      Replay to: <b>rohit@meetpeople.com</b>
                    </Typography>
                  </li>
                </Box>
              </ul>
            </Grid>
          </Grid>
        </Grid>
        <Box className={styles.job_description} sx={{ paddingTop: '0 !important', }}>
          <Box sx={{ color: customTextColor, padding: '15px 15px 70px !important' }}>

            <Typography sx={{ padding: '0 10px 80px 0' }}>Job description</Typography>

            <hr></hr>
            <Typography>Mandatory Skills</Typography>
          </Box>
        </Box>


        {/* <div style={{ backgroundColor: '#fff', padding: '14px 20px 15px 20px' }}>
          <Box className={styles.job_description} sx={{ backgroundColor: '#f0f2f5', padding: '0' }}>
            <Box sx={{ color: customTextColor, padding: '15px 15px 70px !important', border: '1px solid #ccc !important' }}>
              <Typography>BDM Signature</Typography>
            </Box>
          </Box>
        </div> */}
        <div style={{ backgroundColor: '#fff', padding: '14px 20px 15px 20px' }}>
          <Box className={styles.recruiter_profile}>
            <div >
              <img src={profile_image} alt="" />
              <span style={{ color: customTextColor }}>
                <Typography style={{ marginBottom: '12px ' }}>
                  <b>  Thanks & Regrads  </b>
                </Typography>
                <Typography>
                  <b> Ajit Kumar Gahan</b>
                </Typography>
                <Typography>
                  UI Designer at Tek Inspiration
                </Typography>
                <Typography sx={{ margin: "0 !important" }}>
                  E-mail: Ajit@tekinspirations.com,  Ph : 77012 54720
                </Typography>
              </span>
            </div>
          </Box>
        </div>
        <Box className={styles.send_update_btns}>
          <button
            style={{ marginLeft: "15px", backgroundColor: "#4285f4" }}>
            Sent To Both
          </button>
          <Box >
            <span className={styles.send_update_btns}>
              <button
                style={{ backgroundColor: "#3856a6", marginRight: '0' }}
                onClick={() => navigate('/mass-mailing-portal-new')}>
                Send Again
              </button>
            </span>
          </Box>
        </Box>
      </Box>
      </>

    // </RootComponents>
  );
};

export default MassMailingPortalNew;
